import { render } from "./ActivityDetails.vue?vue&type=template&id=037db82b&scoped=true"
import script from "./ActivityDetails.vue?vue&type=script&lang=js"
export * from "./ActivityDetails.vue?vue&type=script&lang=js"

import "./ActivityDetails.vue?vue&type=style&index=0&id=037db82b&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037db82b"]])

export default __exports__